import "../../App.css";
import "./policies.css"; // <-- Importa el archivo CSS compartido aquí
import { useEffect } from "react";
import MainSection from "../../secciones/MainSection/MainSection";

function PrivacyPolicy() {
  // Scroll al inicio cuando se carga la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainSection />
      <section className="policy-section">
        <div className="policy-container">
          
          <header className="policy-header">
            <h1 className="title policy-title">
              Política de Protección de Datos Personales
            </h1>
            <p className="subtitle policy-subtitle">
              Última actualización: <strong>28 de julio de 2026</strong>
            </p>
          </header>

          <article className="description policy-description">
            <p>
              En <strong>One Learning</strong> tratamos los datos personales de manera directa, responsable y conforme a la normativa peruana de protección de datos personales. La información que las personas usuarias entregan a través de este sitio web, formularios, correo electrónico, WhatsApp u otros canales de contacto será utilizada únicamente para finalidades legítimas, informadas y vinculadas a nuestros cursos, servicios y atención comercial.
            </p>

            <h3 className="policy-section-title">1. Responsable del tratamiento</h3>
            <p>
              <strong>Entidad:</strong> One Learning <br />
              <strong>Correo de contacto:</strong> <a href="mailto:contacto@onelearning.pe" className="policy-link">contacto@onelearning.pe</a> <br />
              <strong>Domicilio:</strong> Av. General San Martín 512, dpto 203, Barranco, Código Postal 15063, Lima – Perú
            </p>

            <h3 className="policy-section-title">2. Datos recopilados y finalidad</h3>
            <p>
              Los datos que podemos recopilar incluyen, según el caso, nombres y apellidos, correo electrónico, número de teléfono, empresa, cargo y cualquier otra información que la persona titular proporcione de manera voluntaria. Dichos datos se utilizarán para atender consultas, brindar información sobre programas y cursos, gestionar inscripciones, coordinar reuniones o comunicaciones de seguimiento y mejorar la atención brindada.
            </p>

            <h3 className="policy-section-title">3. Uso de información y terceros</h3>
            <p>
              One Learning no vende, alquila, cede ni comercializa datos personales con terceros para fines publicitarios o comerciales ajenos a la relación con la persona titular. Solo podrá compartir información cuando exista obligación legal, cuando sea necesario para la prestación del servicio solicitado o cuando intervengan proveedores que actúen por cuenta de One Learning bajo deber de confidencialidad y con medidas adecuadas de seguridad.
            </p>

            <h3 className="policy-section-title">4. Consentimiento y Seguridad</h3>
            <p>
              El tratamiento de los datos personales se realiza con respeto al consentimiento de su titular, cuando este sea exigible, el cual debe ser libre, previo, informado, expreso e inequívoco. Asimismo, se adoptan medidas razonables de seguridad para evitar el acceso no autorizado, la pérdida, el uso indebido o la alteración de la información personal.
            </p>

            <h3 className="policy-section-title">5. Derechos ARCO</h3>
            <p>
              La persona titular puede ejercer sus derechos de acceso, rectificación, cancelación y oposición, así como revocar su consentimiento cuando corresponda. También puede solicitar, en cualquier momento, que dejemos de enviarle mensajes, correos, llamadas o cualquier otra comunicación de contacto o difusión, escribiendo a <a href="mailto:contacto@onelearning.pe" className="policy-link">contacto@onelearning.pe</a>.
            </p>

            <h3 className="policy-section-title">6. Baja de comunicaciones</h3>
            <p>Para dejar de recibir comunicaciones de One Learning, bastará con:</p>
            <ul className="policy-list">
              <li>Responder cualquiera de nuestros mensajes indicando que no desea continuar recibiendo comunicaciones.</li>
              <li>Escribirnos a <a href="mailto:contacto@onelearning.pe" className="policy-link">contacto@onelearning.pe</a> con el asunto “Protección de datos” o “Baja de comunicaciones”.</li>
              <li>Solicitar expresamente la exclusión de nuestras bases de contacto o listas de difusión.</li>
            </ul>

            <h3 className="policy-section-title">7. Reclamos y solicitudes</h3>
            <p>
              Las solicitudes vinculadas a datos personales serán atendidas por los canales de contacto informados en este sitio web, previa validación razonable de identidad cuando corresponda. Si la persona titular considera que sus derechos no han sido debidamente atendidos, puede acudir a la Autoridad Nacional de Protección de Datos Personales del Ministerio de Justicia y Derechos Humanos del Perú.
            </p>

            <h3 className="policy-section-title">8. Actualizaciones</h3>
            <p className="policy-highlight">
              One Learning podrá actualizar esta política para reflejar cambios normativos, operativos o de servicio. La versión vigente será siempre la publicada en este sitio web (onelearning.pe).
            </p>
          </article>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;